import { Camera, Gift, Link, MediaImage, Megaphone, SendDiagonal } from 'iconoir-react';
import type { ComponentType, SVGProps } from 'react';

/**
 * Static name -> iconoir component map for the collaboration rail rows.
 *
 * The fixture stores the glyph as a string (`icon: 'Link' | 'MediaImage' | ...`)
 * so it stays serialisable for the eventual real API. Resolving through this
 * explicit map keeps the imports tree-shakeable and type-safe — a dynamic
 * `iconoir[name]` lookup would pull the whole icon set and lose the union check.
 */
export type ContactNavIconName =
  | 'Camera'
  | 'Link'
  | 'MediaImage'
  | 'Gift'
  | 'Megaphone'
  | 'SendDiagonal';

export const CONTACT_NAV_ICONS: Record<
  ContactNavIconName,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  Camera,
  Link,
  MediaImage,
  Gift,
  Megaphone,
  SendDiagonal,
};
